import { useContext } from 'react';

import { ThemingContext } from "./";

export const useGetTheme = () => {
    const [theme] = useContext(ThemingContext);
    return theme || {};
};
